<template>
  <div class="wrap" v-if="showWrap" :class="showContent ?'fadein':'fadeout'">{{text}}</div>
</template>

<script>
export default {

}
</script>

<style scoped>
.wrap {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  width: max-content;
  max-width: calc(100vw - 32px);
  max-width: min(480px, calc(100vw - 32px));
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  overflow-wrap: break-word;
  overflow-wrap: anywhere;
  padding: 14px 22px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  background: #303744;
  box-shadow: 0 8px 28px rgba(24, 32, 48, 0.16),
    0 2px 6px rgba(24, 32, 48, 0.08);
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.65;
  letter-spacing: 0.02em;
  text-align: center;
  z-index: 30;
}

.fadein {
  animation: animate_in 0.25s ease-out;
}

.fadeout {
  animation: animate_out 0.25s ease-in;
  opacity: 0;
}

@keyframes animate_in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes animate_out {
  from { opacity: 1; }
  to { opacity: 0; }
}

@media (max-width: 480px) {
  .wrap {
    padding: 12px 18px;
    border-radius: 12px;
    font-size: 14px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fadein,
  .fadeout {
    animation: none;
  }
}
</style>
